<template>
  <div v-if="isStarted && dataSource.length">
    <label>{{ $t('history') }}</label>
    <HKLTable
      :columns="columns"
      :dataSource="dataSource"
    />
  </div>
</template>

<script>
import lodash from 'lodash'
import { computed, unref } from 'vue-demi'
import HKLTable from '@/controls/Table/HKLTable'
import { useStoreGetters } from '@/store'
import i18n from '@/utils/i18n'
import dateUtil from '../../../../utils/dateUtil'
import { GREEN_OPERATION_HISTORY_TYPE } from './consts'
import { useGreenOperationHistories, useGreenOperationStatus } from './hook'
import {
  isSppHistoryOnOrAfterEffectiveDate,
  resolveSppLifecycleEffectiveDate,
} from './sppLifecycleEffectiveDate'

export default {
  components: {
    HKLTable,
  },
  setup () {
    const histories = useGreenOperationHistories()
    const { isStarted } = useGreenOperationStatus()
    const { setting } = useStoreGetters('settings', 'setting')
    const dataSource = computed(() => {
      const effectiveDate = resolveSppLifecycleEffectiveDate(unref(setting))
      const list = unref(histories)
        .filter((history) => history.type === GREEN_OPERATION_HISTORY_TYPE.HISTORY)
        .filter((history) => isSppHistoryOnOrAfterEffectiveDate(history.createdAt, effectiveDate))
        .reduce((list, history) => {
          list.push({
            createdAt: history.createdAt,
            type: history.status,
            createdBy: history.who.displayName,
            comment: history.detail.comments,
          })
          return list
        }, [])
      return lodash.orderBy(lodash.uniq(list), ['createdAt'], ['desc'])
    })
    const columns = computed(() => [{
      dataIndex: 'createdAt',
      title: i18n.t('table.header.date'),
      render: (val) => dateUtil.format(val, dateUtil.DD_MMM_YY_HH_MM),
    }, {
      dataIndex: 'type',
      title: i18n.t('table.header.action'),
      render: (val) => i18n.t(`tenancy.greenOperation.columns.${val}`),
    }, {
      dataIndex: 'createdBy',
      title: i18n.t('table.header.actionBy'),
    }, {
      dataIndex: 'comment',
      title: i18n.t('table.header.comment'),
    }])
    return {
      isStarted,
      dataSource,
      columns,
    }
  },
}
</script>

<style lang="scss" scoped>
.hkl-table {
  margin-left: 0;
  margin-right: 0;
}
</style>
